define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DynamicDomain = void 0;
    class DynamicDomain {
        constructor() {
            Object.defineProperty(this, "values", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "KeyIndex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ValueIndex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.values = [];
            this.KeyIndex = {};
            this.ValueIndex = {};
        }
        add(item) {
            this.addByKv(item.key, item.value);
        }
        addByKv(key, value) {
            this.values.push({ key, value });
            this.KeyIndex[key] = this.values.length - 1;
            this.ValueIndex[value] = this.values.length - 1;
        }
        get Values() {
            return this.values;
        }
        findByValue(value) {
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        findByKey(key) {
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
        get length() {
            return this.values.length;
        }
        static createFromDomain(source, keysToExclude = []) {
            let domain = new DynamicDomain();
            for (let x of source.Values) {
                if (keysToExclude.indexOf(x.key) == -1) {
                    domain.addByKv(x.key, x.value);
                }
            }
            return domain;
        }
        static createFromArray(source, keyResolver, valResolver) {
            let domain = new DynamicDomain();
            for (let x of source) {
                let key = typeof keyResolver === "string" ? x[keyResolver] : keyResolver(x);
                let val = typeof valResolver === "string" ? x[valResolver] : valResolver(x);
                domain.addByKv(key, val);
            }
            return domain;
        }
    }
    exports.DynamicDomain = DynamicDomain;
});
